// Human-readable descriptions of the built-in roles. Keyed by Responsible.name
// because that is what the backend uses to gate behaviour (see invoices.controller.js
// and user.controller.js). Custom responsibles created by an Admin will simply
// show no description — that is intentional, this map is for the seeded roles.
export const ROLE_DESCRIPTIONS = {
  Admin:
    "Full access. Manages users on every vessel and the office, manages the role list. CRUD invoices for every department.",
  TSI: "Technical Superintendent. Manages users on vessel only. Cannot manage office users, cannot create or assign the Admin role, and cannot move users between vessels. Sees invoices for the Technical and Operations departments and unassigned.",
  Accountant:
    "Sees invoices for every department, like an Admin, but cannot delete them or manage users.",
  MSI: "Sees invoices for the Technical and Operations departments and Unassigned. Certificates management.",
  FTM: "Fleet/Technical Manager. Sees invoices for the Technical and Operations departments and Unassigned.",
  Crewing:
    "Crewing department. Sees invoices for the Crewing department and Unassigned.",
};
